import { gridGalleryConfig } from '../config/gridGalleryConfig'

interface GridZoomControlsProps {
  onZoomIn: () => void
  onZoomOut: () => void
  zoomLevelIndex: number
  maxZoomIndex: number
}

export default function GridZoomControls({
  onZoomIn,
  onZoomOut,
  zoomLevelIndex,
  maxZoomIndex,
}: GridZoomControlsProps) {
  const { zoomLevels } = gridGalleryConfig
  const currentLevel = zoomLevels[zoomLevelIndex]
  const canZoomIn = zoomLevelIndex < maxZoomIndex
  const canZoomOut = zoomLevelIndex > 0

  return (
    <div className="absolute bottom-20 sm:bottom-6 right-4 sm:right-6 z-50 flex flex-col gap-2">
      {/* Zoom In (fewer columns = bigger images) */}
      <button
        onClick={onZoomIn}
        disabled={!canZoomIn}
        className="w-11 h-11 sm:w-10 sm:h-10 bg-white/90 backdrop-blur-sm rounded-full shadow-lg flex items-center justify-center hover:bg-white active:scale-95 transition-all touch-manipulation disabled:opacity-30 disabled:cursor-not-allowed"
        title="Zoom In"
        aria-label="Zoom in"
      >
        <svg className="w-5 h-5 text-gray-700" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
        </svg>
      </button>

      {/* Zoom Out (more columns = smaller images) */}
      <button
        onClick={onZoomOut}
        disabled={!canZoomOut}
        className="w-11 h-11 sm:w-10 sm:h-10 bg-white/90 backdrop-blur-sm rounded-full shadow-lg flex items-center justify-center hover:bg-white active:scale-95 transition-all touch-manipulation disabled:opacity-30 disabled:cursor-not-allowed"
        title="Zoom Out"
        aria-label="Zoom out"
      >
        <svg className="w-5 h-5 text-gray-700" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 12H4" />
        </svg>
      </button>

      {/* Grid size indicator */}
      <div className="bg-black/60 backdrop-blur-sm text-white text-xs text-center rounded-full px-2 py-1.5 min-w-[48px] font-medium">
        {currentLevel.columns}
      </div>
    </div>
  )
}
